// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___3ER63","title":"style__title___3alsy","subtitle":"style__subtitle___3F1ty","inputContainer":"style__inputContainer___f-zoy","inputError":"style__inputError___1G4nK","input":"style__input___23dbu","inputMessage":"style__inputMessage___FbXRF","inputPassword":"style__inputPassword___3Sj1d","error":"style__error___iN6RL","button":"style__button___28R1b","text":"style__text___2EYM3","textBold":"style__textBold___2_ss6","backButton":"style__backButton___21xeh"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/resetpassword/style.css
// module id = 1035
// module chunks = 0